// 문자열 기반 결정적 색상 (아바타 배경 · 모드 점/테두리 등 공용 팔레트)
const PALETTE = ["#645ad2", "#3aa6b9", "#e879a6", "#e0a13c", "#c2562f", "#5b8def", "#9a6ad6", "#4bb89a", "#d65b7a"];

export const colorFromString = (s: string): string => {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
};
